import { render, staticRenderFns } from "./CreateStatementChange.vue?vue&type=template&id=5f05d29f"
import script from "./CreateStatementChange.vue?vue&type=script&lang=js"
export * from "./CreateStatementChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports